import LastUpdatedIndicator from "../LastUpdatedIndicator";
import InstrumentDetailsTable from "./InstrumentDetailsTable";
import React, {useContext} from "react";
import Context from "../../../contexts/MarketPerformanceContext";
import {LottieLoader} from "../../../utilities/Loaders";
import {VoidState} from "../../../utilities/VoidState";
import BackLink from "../Components/BackLink";

const FullInstrumentsView = () => {
    const {state: { fullInstruments, loading }, backToOverview} = useContext(Context);

    if (loading) {
        return <LottieLoader className={'text-center'}/>
    }

    return (
        <div className="section">
            <div className="container">
                <div className="nzdx-instruments">
                    <div className="d-flex justify-content-between mb-5">
                        <BackLink handleOnclick={backToOverview} />
                        <div className="d-xl-block d-none">
                            <LastUpdatedIndicator />
                        </div>
                    </div>
                    <div className="instrument-table mt-3">
                        {(!fullInstruments || fullInstruments.length === 0) ? (
                            <VoidState message={'Instrument details not available'}/>
                        ) : (
                            <InstrumentDetailsTable instruments={fullInstruments} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FullInstrumentsView;